import config from '../../../config'

const appUrl = config.app.url
const isLocal = config.isLocal

export const getPlatformFromHostname = () => {
  const hostname = window?.location?.hostname ?? ''
  if (!/movingwaldo\.com$/.test(hostname)) {
    return null
  }
  const platform = hostname
    .toLowerCase()
    .replace(/staging[0-9]*\./, '')
    .replace('local.', '')
    .replace('booking.', '')
    .replace(/\.?movingwaldo\.com/, '')

  if (!/^[a-z0-9-]{3,30}$/.test(platform)) {
    return null
  }

  return platform || null
}

export const replacePlatformInUrl = (platform: string) => {
  const path = `${window?.location?.pathname}${window?.location?.search}`
  if (isLocal) {
    const localDomain = appUrl.replace('localhost', `${platform}.local.movingwaldo.com`)
    return `${localDomain}${path}`
  }
  return `${appUrl.replace('://', `://${platform}.`)}${path}`
}

export const removePlatformFromUrl = () => {
  const path = `${window?.location?.pathname}${window?.location?.search}`
  return `${appUrl}${path}`
}
